module.exports = __webpack_public_path__ + "img/PT193.c969170b.png";